import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import HireTalent from "@/pages/HireTalent";
import SubmitResume from "@/pages/SubmitResume";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import KnowledgeHub from "@/pages/KnowledgeHub";
import HubPost from "@/pages/HubPost";
import AdminLogin from "@/pages/AdminLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value || "");
}

function applyHead(seo, path) {
  if (!seo) return;
  const pageOverride = (seo.pages && seo.pages[path]) || {};
  const title = pageOverride.title || seo.title;
  const description = pageOverride.description || seo.description;
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "keywords", seo.keywords);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:type", "website");
  if (seo.og_image) setMeta("property", "og:image", `${BACKEND}/api/media/${seo.og_image}`);
  // JSON-LD Organization schema for AI search (GEO/AEO)
  let ld = document.getElementById("iws-jsonld");
  if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "iws-jsonld"; document.head.appendChild(ld); }
  ld.text = JSON.stringify({ "@context": "https://schema.org", "@type": "Organization", name: seo.org_name || "Ishaan Workforce Solutions", url: seo.org_url || window.location.origin, description: seo.description });
  // GA4
  if (seo.ga4_id && !document.getElementById("ga4-src")) {
    const s = document.createElement("script"); s.id = "ga4-src"; s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${seo.ga4_id}`; document.head.appendChild(s);
    const i = document.createElement("script"); i.id = "ga4-init"; i.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${seo.ga4_id}');`; document.head.appendChild(i);
  }
}

function SeoTracker() {
  const loc = useLocation();
  const [seo, setSeo] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setSeo(r.data.seo || {})).catch(() => {}); }, []);
  useEffect(() => { if (seo) applyHead(seo, loc.pathname); }, [seo, loc.pathname]);
  useEffect(() => {
    api.post("/track", { path: loc.pathname, referrer: document.referrer || "" }).catch(() => {});
    if (window.gtag) window.gtag("event", "page_view", { page_path: loc.pathname });
  }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SeoTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<Jobs />} />
            <Route path="/hire-talent" element={<HireTalent />} />
            <Route path="/submit-resume" element={<SubmitResume />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hub" element={<KnowledgeHub />} />
            <Route path="/hub/:slug" element={<HubPost />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
